import styled, { css } from 'styled-components';
import { mobile_s, mobile_xl, mobile_xs } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  .loading-animation {
    overflow: hidden;
  }
  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }
  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

const Box = styled.div`
  width: 100%;
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  border-radius: var(--border-radius-12);
`;

const Content = styled.div`
  padding: var(--space-10) var(--space-14);
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
`;

const Top = styled.div`
  ${FlexBetween}
  gap: var(--space-10);
`;

const Bottom = styled.div`
  max-width: 378px;
  width: 100%;
  height: 10px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xl(css`
    width: 100%;
    max-width: 260px;
  `)}
`;

const Left = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
  .first-line {
    width: 337px;
  }
  .third-line {
    width: 138px;
  }
  .forth-line {
    width: 459px;
  }
  ${mobile_xl(css`
    .first-line {
      width: 285px;
    }
    .second-line {
      width: 210px;
    }
    .third-line {
      width: 246px;
    }
    .forth-line {
      width: 186px;
    }
  `)}
`;

const Right = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
  .dot-icon {
    cursor: pointer;
    path {
      fill: var(--text-tertiary);
    }
  }
  ${mobile_xl(css`
    .dot-icon {
      display: none;
    }
  `)}
`;

const Circle = styled.div`
  width: 14px;
  height: 14px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xl(css`
    width: 18px;
    height: 18px;
  `)}
`;

const LeftLine = styled.div`
  width: 243px;
  height: 12px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xl(css`
    width: 200px;
  `)}
  ${mobile_s(css`
    width: 160px;
  `)}
  ${mobile_xs(css`
    width: 130px;
  `)}
`;

const Users = styled.div`
  display: flex;
`;

const User = styled.div`
  border-radius: var(--border-radius-full);
  border: 2px solid var(--background-primary);
  background: var(--background-muted);
  width: 24px;
  height: 24px;
  margin-left: -9px;
  ${mobile_xl(css`
    width: 20px;
    height: 20px;
  `)}
`;

const Content1 = styled.div`
  padding: var(--space-10) var(--space-14);
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
`;

const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  border-top: 0.5px solid var(--border-primary);
  .first {
    padding-top: var(--space-10);
  }
  ${mobile_xl(css`
    gap: var(--space-16);
  `)}
`;

const Div = styled.div`
  width: 14px;
  height: 14px;
  ${mobile_xl(css`
    width: 18px;
    height: 18px;
  `)}
`;

export { Main, Box, Content, Top, Bottom, Left, Right, Circle, LeftLine, Users, User, Content1, BottomContent, Div };
